import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { SeriesPoint } from '../lib/api';
import { formatCurrency, formatDate } from '../lib/format';

// `currency` formata o eixo/tooltip desta série — cada moeda tem seu
// próprio gráfico (nunca a mesma barra somando vendas de moedas
// diferentes, ver seriesByCurrency em lib/api.ts).
// `showRevenue` (padrão true, admin) controla a barra/legenda de
// faturamento — InfluencerDashboardPage.tsx passa `false` (pedido
// explícito do proprietário, 2026-09-09: parceiro só vê a própria
// comissão, nunca o faturamento bruto da venda).
export function SalesChart({
  series,
  currency,
  showRevenue = true,
}: {
  series: SeriesPoint[];
  currency: string;
  showRevenue?: boolean;
}) {
  if (series.length === 0) {
    return (
      <div className="card flex h-72 items-center justify-center p-5 text-sm text-[rgb(var(--text-muted))]">
        Nenhuma venda no período selecionado.
      </div>
    );
  }

  return (
    <div className="card h-72 p-5">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={series} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgb(var(--border))" />
          <XAxis
            dataKey="date"
            tickFormatter={(value: string) => formatDate(value)}
            tick={{ fontSize: 12, fill: 'rgb(var(--text-muted))' }}
            axisLine={{ stroke: 'rgb(var(--border))' }}
            tickLine={false}
          />
          <YAxis tick={{ fontSize: 12, fill: 'rgb(var(--text-muted))' }} axisLine={false} tickLine={false} width={36} />
          <Tooltip
            labelFormatter={(value: string) => formatDate(value)}
            formatter={(value: number, name: string) => [
              name === 'salesCount' ? value : formatCurrency(value, currency),
              name === 'salesCount' ? 'Vendas' : name === 'revenue' ? 'Faturamento' : 'Comissão',
            ]}
            contentStyle={{ borderRadius: 0, borderColor: 'rgb(var(--border))' }}
          />
          <Legend
            formatter={(value: string) => (value === 'salesCount' ? 'Vendas' : value === 'revenue' ? 'Faturamento' : 'Comissão')}
          />
          {showRevenue ? <Bar dataKey="revenue" fill="#D14D23" radius={0} /> : null}
          <Bar dataKey="commission" fill="#1D9E75" radius={0} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
